import axiosInstance from '../common/interceptor/axios-interceptor'
import Config from '../config/config'

const BASE_URL = Config.getBaseUrl()

export const loginAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}sign-in`,
    data: data,
  })
}

export const createAccountAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}create-account`,
    data: data,
  })
}

export const sendOTPAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}send-otp`,
    data: data,
    authRequired: true,
  })
}

export const sendUnAuthOTPAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}unauth/send-otp`,
    data: data,
  })
}

export const validateUnAuthOTPAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}unauth/verify-otp`,
    data: data,
  })
}

export const validateOTPAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}verify-otp`,
    data: data,
    authRequired: true,
  })
}

export const forgotPasswordAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}unauth/forgot-password`,
    data: data,
  })
}

export const documentUploadAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}document-upload`,
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    authRequired: true,
  })
}

export const addBranchAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add`,
    data: data,
    authRequired: true,
  })
}

export const updateVisibilityAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-online-order-visibility`,
    data: data,
    authRequired: true,
  })
}

// export const updateBranchAPI = async data => {
//     return axiosInstance({
//         method: 'post',
//         url: `${BASE_URL}branches/add`,
//         data: data,
//         authRequired: true
//     })
// }

export const getBranchAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-branches`,
    data: data,
    authRequired: true,
  })
}

export const updateBranchAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-branch`,
    data: data,
    authRequired: true,
  })
}

export const updateBranchDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-branch-details`,
    data: data,
    authRequired: true,
  })
}

export const addUserAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add-user`,
    data: data,
    authRequired: true,
  })
}

export const updateUserAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-user`,
    data: data,
    authRequired: true,
  })
}

export const getUserAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-users`,
    data: data,
    authRequired: true,
  })
}

export const getProductsAPI = async (data, signal) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}products`,
    data: data,
    authRequired: true,
    signal,
  })
}

export const getProductDataAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-products`,
    data: data,
    authRequired: true,
  })
}

export const getMedicalCategoryAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-product-categories`,
    data: data,
    authRequired: true,
  })
}

export const updateProductDataAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-product-details`,
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    authRequired: true,
  })
}

export const getSuppliersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-suppliers`,
    data: data,
    authRequired: true,
  })
}

export const addSuppliersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add-supplier`,
    data: data,
    authRequired: true,
  })
}

export const updateSuppliersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-supplier-details`,
    data: data,
    authRequired: true,
  })
}

export const getVendorsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-vendors`,
    data: data,
    authRequired: true,
  })
}

export const addVendorAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add-vendor`,
    data: data,
    authRequired: true,
  })
}

export const updateVendorAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-vendor-details`,
    data: data,
    authRequired: true,
  })
}

export const addProductReceivingAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add-product-receiving`,
    data: data,
    authRequired: true,
  })
}

export const getProductReceivingAPI = async (data, params) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-product-receivings`,
    data: data,
    params,
    authRequired: true,
  })
}

export const updateProductReceivingAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-product-receiving`,
    data: data,
    authRequired: true,
  })
}

export const updateProductReceivingStatusAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-product-receiving-status`,
    data: data,
    authRequired: true,
  })
}

export const deleteProductReceivingAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/delete-product-receiving`,
    data: data,
    authRequired: true,
  })
}

export const searchCustomersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/search-customers`,
    data: data,
    authRequired: true,
  })
}

export const getAllCustomersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-customers`,
    data: data,
    authRequired: true,
  })
}

export const getCustomerAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-customer-by-mobile-no`,
    data: data,
    authRequired: true,
  })
}

export const addCustomerAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add-customer`,
    data: data,
    authRequired: true,
  })
}

export const updateCustomerAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-customer`,
    data: data,
    authRequired: true,
  })
}

export const getCustomerSalesOrdersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-customer-sales-orders`,
    data: data,
    authRequired: true,
  })
}

export const getProductDetailsByBarcodeAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-product-detail-from-barcode`,
    data: data,
    authRequired: true,
  })
}

export const getDamageLossAdjustmentAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-damage-loss-adjustments`,
    data: data,
    authRequired: true,
  })
}

export const addDamageLossAdjustmentAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/create-damage-loss-adjustment`,
    data: data,
    authRequired: true,
  })
}

export const deleteDamageLossAdjustmentAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/delete-damage-loss-adjustment`,
    data: data,
    authRequired: true,
  })
}

export const updateDamageLossAdjustmentAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-damage-loss-adjustment`,
    data: data,
    authRequired: true,
  })
}

export const getStoreReturnsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-store-returns`,
    data: data,
    authRequired: true,
  })
}

export const addStoreReturnAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/create-store-return`,
    data: data,
    authRequired: true,
  })
}

export const updateStoreReturnAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-store-return`,
    data: data,
    authRequired: true,
  })
}

export const deleteStoreReturnAPI = async (id) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/delete-store-return`,
    data: { id },
    authRequired: true,
  })
}

export const getInventoryDetailsAPI = async (data, params) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-inventory`,
    data: data,
    params,
    authRequired: true,
  })
}

export const getCrossBranchInventoryAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-cross-branch-inventory`,
    data: data,
    authRequired: true,
  })
}

export const getCampaignInventoryDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-discount-campaign-inventory`,
    data: data,
    authRequired: true,
  })
}

export const getProductDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-product-details`,
    data: data,
    authRequired: true,
  })
}

export const getInvoiceDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-product-receiving`,
    data: data,
    authRequired: true,
  })
}

export const getAllSalesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-sales-orders`,
    data: data,
    authRequired: true,
  })
}

export const getSalesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-sales-order-by-id`,
    data: data,
    authRequired: true,
  })
}

export const createSalesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/hold-or-create-sales-order`,
    data: data,
    authRequired: true,
  })
}

export const addProductToSalesOrderAPI = async (
  salesOrderId,
  productId,
  batchId,
  data
) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/sales-order/${salesOrderId}/product/${productId}/batch/${batchId}/add`,
    data: data, // e.g. { quantity: 5 }
    authRequired: true,
  })
}

export const updateProductFromSaleOrderAPI = async (
  salesOrderId,
  itemId,
  data
) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/sales-order/${salesOrderId}/product/${itemId}/edit`,
    data,
    authRequired: true,
  })
}

export const deleteProductFromSalesOrderAPI = async (salesOrderId, itemId) => {
  return axiosInstance({
    method: 'delete',
    url: `${BASE_URL}branches/sales-order/${salesOrderId}/product/${itemId}`,
    authRequired: true,
  })
}

export const deleteSalesOrderAPI = async (salesOrderId) => {
  return axiosInstance({
    method: 'delete',
    url: `${BASE_URL}branches/sales-order/${salesOrderId}/bulk-delete`,
    authRequired: true,
  })
}

export const cancelHoldSalesOrderAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/cancel-hold-sales-order`,
    data: data,
    authRequired: true,
  })
}

export const updateSalesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-sales-order`,
    data: data,
    authRequired: true,
  })
}

export const getExpiredProductsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-expired-products`,
    data: data,
    authRequired: true,
  })
}

export const getExpiredProductDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-expired-product-details`,
    data: data,
    authRequired: true,
  })
}

export const returnExpiredProductsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/return-expired-product`,
    data: data,
    authRequired: true,
  })
}

export const getPersonalDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-user-personal-details`,
    data: data,
    authRequired: true,
  })
}

export const updatePersonalDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-user-personal-details`,
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    authRequired: true,
  })
}

export const getNotificationsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-notifications`,
    data: data,
    authRequired: true,
  })
}

export const updateNotificationsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-notifications`,
    data: data,
    authRequired: true,
  })
}

export const getDocumentsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-documents`,
    data: data,
    authRequired: true,
  })
}

export const getSalesOrderByInvoiceNumberAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-sales-order-by-invoice-number`,
    data: data,
    authRequired: true,
  })
}

export const createExchangeReturnAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/exchange-or-return-sales-order`,
    data: data,
    authRequired: true,
  })
}

export const getAllExchangeReturnOrdersAPI = async (data, params) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-exchange-or-return-sales-orders`,
    data: data,
    params: params,
    authRequired: true,
  })
}

export const getExchangeReturnOrdersByIdAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-exchange-or-return-sales-order-by-id`,
    data: data,
    authRequired: true,
  })
}

export const addQueryAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add-query`,
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    authRequired: true,
  })
}

export const getQueriesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-queries`,
    data: data,
    authRequired: true,
  })
}

export const updateQueryAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-query`,
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    authRequired: true,
  })
}

export const deleteQueryAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/delete-query`,
    data: data,
    authRequired: true,
  })
}

export const addReminderAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add-reminder`,
    data: data,
    authRequired: true,
  })
}

export const deleteReminderAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/delete-reminder`,
    data: data,
    authRequired: true,
  })
}

export const getReminderAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-reminders`,
    data: data,
    authRequired: true,
  })
}

export const getDeliveryPartnersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-delivery-partners`,
    data: data,
    authRequired: true,
  })
}

export const addDeliveryPartnerAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/add-delivery-partner`,
    data: data,
    authRequired: true,
  })
}

export const confirmOnlineSalesOrderAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/confirm-online-sales-order`,
    data: data,
    authRequired: true,
  })
}

export const getOrderBookAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-order-books`,
    data: data,
    authRequired: true,
  })
}

export const addOrderBookAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/create-new-order-book`,
    data: data,
    authRequired: true,
  })
}

export const getOrderBookDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-order-book-details`,
    data: data,
    authRequired: true,
  })
}

export const updateOrderBookStatusAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-order-book-status`,
    data: data,
    authRequired: true,
  })
}

export const updateOrderBookAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-order-book`,
    data: data,
    authRequired: true,
  })
}

export const getOrderBookSearchSuggestionsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-search-suggestions`,
    data: data,
    authRequired: true,
  })
}

export const getOrderBookSearchResultsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}get-search-results`,
    data: data,
    authRequired: true,
  })
}

export const getProductSearchSuggestionsAPI = async (data, signal) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-product-search-suggestions`,
    data: data,
    authRequired: true,
    signal,
  })
}

export const getProductDetailByIdAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-product-detail-by-id`,
    data: data,
    authRequired: true,
  })
}

export const getProductSearchResultsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-product-search-results`,
    data: data,
    authRequired: true,
  })
}

export const createSingleProductDiscountAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/create-single-product-discount`,
    data: data,
    authRequired: true,
  })
}

export const updateSingleProductDiscountAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-single-product-discount`,
    data: data,
    authRequired: true,
  })
}

export const getSingleProductDiscountAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-single-product-discounts`,
    data: data,
    authRequired: true,
  })
}

export const createCampaignDiscountAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/create-discount-campaign`,
    data: data,
    authRequired: true,
  })
}

export const getCampaignDiscountAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-discount-campaigns`,
    data: data,
    authRequired: true,
  })
}

export const getCampaignDiscountDetailAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-discount-campaign-details`,
    data: data,
    authRequired: true,
  })
}

export const updateCampaignDiscountAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-discount-campaign`,
    data: data,
    authRequired: true,
  })
}

export const getAccountingAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-accouting`,
    data: data,
    authRequired: true,
  })
}

export const enableAccountingAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/enable-accouting`,
    data: data,
    authRequired: true,
  })
}

export const getVouchersAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-vouchers`,
    data: data,
    authRequired: true,
  })
}

export const getVoucherDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-voucher-details`,
    data: data,
    authRequired: true,
  })
}

export const createVoucherAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/create-voucher`,
    data: data,
    authRequired: true,
  })
}

export const updateVoucherAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-voucher`,
    data: data,
    authRequired: true,
  })
}

export const getProfitLossStatementAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-profit-loss-statement`,
    data: data,
    authRequired: true,
  })
}

export const getBalanceSheetStatementAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-balance-sheet-statement`,
    data: data,
    authRequired: true,
  })
}

export const getReceiptPaymentAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-receipts-and-payments`,
    data: data,
    authRequired: true,
  })
}

export const getStatisticsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-statistics`,
    data: data,
    authRequired: true,
  })
}

export const getStoreStatusAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-online-order-visibility`,
    data: data,
    authRequired: true,
  })
}

export const getStocksAndBarchartDataAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-stock-and-bar-chart-data`,
    data: data,
    authRequired: true,
  })
}

export const updateDeliveryPartnerStatusAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-delivery-partner`,
    data: data,
    authRequired: true,
  })
}

export const updatePrescriptionOrderAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-online-prescription-sales-order`,
    data: data,
    authRequired: true,
  })
}

export const updatePasswordAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}update-password`,
    data: data,
    authRequired: true,
  })
}

export const getReportAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-reports`,
    data: data,
    authRequired: true,
  })
}

export const downloadReportExcelAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-reports-excel`,
    data: data,
    responseType: 'blob',
    authRequired: true,
  })
}

export const downloadReportPdfAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-reports-pdf`,
    data: data,
    responseType: 'blob',
    authRequired: true,
  })
}

export const getPlatformChargesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-platform-charges`,
    data: data,
    authRequired: true,
  })
}

export const payPlatformChargesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/pay-platform-charges`,
    data: data,
    authRequired: true,
  })
}

export const updatePlatformChargesTransactionStatusAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-platform-charge-transaction-status`,
    data: data,
    authRequired: true,
  })
}

export const getCommissionEarningsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-commission-earnings`,
    data: data,
    authRequired: true,
  })
}

export const payCommissionEarningsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/pay-commission-earnings`,
    data: data,
    authRequired: true,
  })
}

export const updateCommissionTransactionStatusAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-commission-transaction-status`,
    data: data,
    authRequired: true,
  })
}

// Bank Details APIs
export const getBankDetailsAPI = async () => {
  return axiosInstance({
    method: 'get',
    url: `${BASE_URL}branches/banks`,
    authRequired: true,
  })
}

export const addBankDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/banks/add`,
    data: data,
    authRequired: true,
  })
}

export const updateBankDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/banks/update`,
    data: data,
    authRequired: true,
  })
}

export const deleteBankDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/banks/delete`,
    data: data,
    authRequired: true,
  })
}

// MFS Details APIs
export const getMFSDetailsAPI = async () => {
  return axiosInstance({
    method: 'get',
    url: `${BASE_URL}branches/mfs`,
    authRequired: true,
  })
}

export const addMFSDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/mfs/add`,
    data: data,
    authRequired: true,
  })
}

export const updateMFSDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/mfs/update`,
    data: data,
    authRequired: true,
  })
}

export const deleteMFSDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/mfs/delete`,
    data: data,
    authRequired: true,
  })
}

// POS Details APIs
export const getPOSDetailsAPI = async () => {
  return axiosInstance({
    method: 'get',
    url: `${BASE_URL}branches/pos`,
    authRequired: true,
  })
}

export const addPOSDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/pos/add`,
    data: data,
    authRequired: true,
  })
}

export const updatePOSDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/pos/update`,
    data: data,
    authRequired: true,
  })
}

export const deletePOSDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/pos/delete`,
    data: data,
    authRequired: true,
  })
}

// Loan Details APIs
export const getLoanDetailsAPI = async () => {
  return axiosInstance({
    method: 'get',
    url: `${BASE_URL}branches/loans`,
    authRequired: true,
  })
}

export const addLoanDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/loans/add`,
    data: data,
    authRequired: true,
  })
}

export const updateLoanDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/loans/update`,
    data: data,
    authRequired: true,
  })
}

export const deleteLoanDetailsAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/loans/delete`,
    data: data,
    authRequired: true,
  })
}

// Due Sales Payment APIs
export const getDueSalesInvoicesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-due-sales-invoices`,
    data: data,
    authRequired: true,
  })
}

export const payDueSalesOnlineAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/pay-due-sales-online`,
    data: data,
    authRequired: true,
  })
}

export const updateDueSalesPaymentStatusAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-due-sales-payment-status`,
    data: data,
    authRequired: true,
  })
}

// Branch Banks API
export const getBranchBanksAPI = async () => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-branch-banks`,
    authRequired: true,
  })
}

// Due Purchase Payment APIs (Account Payable)
export const getDuePurchaseInvoicesAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/get-due-purchase-invoices`,
    data: data,
    authRequired: true,
  })
}

export const payDuePurchaseOnlineAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/pay-due-purchase-online`,
    data: data,
    authRequired: true,
  })
}

// Address API endpoints
export const getDivisionsAPI = async () => {
  return axiosInstance({
    method: 'get',
    url: `${BASE_URL}address/divisions`,
    authRequired: true,
  })
}

export const updateDuePurchasePaymentStatusAPI = async (data) => {
  return axiosInstance({
    method: 'post',
    url: `${BASE_URL}branches/update-due-purchase-payment-status`,
    data: data,
    authRequired: true,
  })
}

export const getDistrictsAPI = async (divisionId) => {
  return axiosInstance({
    method: 'get',
    url: `${BASE_URL}address/districts?division_id=${divisionId}`,
    authRequired: true,
  })
}

export const getPoliceStationsAPI = async (districtId) => {
  return axiosInstance({
    method: 'get',
    url: `${BASE_URL}address/police-stations?district_id=${districtId}`,
    authRequired: true,
  })
}

export const getPostOfficesAPI = async (policeStationId) => {
  return axiosInstance({
    method: 'get',
    url: `${BASE_URL}address/post-offices?police_station_id=${policeStationId}`,
    authRequired: true,
  })
}
